<template>
<div class="animated fadeIn mt-5">
  <form enctype="multipart/form-data" v-on:submit="validateBeforeSubmit($event,false)" v-if="dataLoaded">
    <div class="row">
      <div class="col-md-6">
        <b-card>
          <div slot="header">
            <strong>Actividade</strong>
          </div>
          <b-form-fieldset label="Nome">
            <b-form-input type="text" name="name" v-model="item.name" placeholder="Nome" v-validate="{ required: true }" :state="validateState('name')" data-vv-validate-on="change" ></b-form-input>
            <b-form-invalid-feedback>
              {{ errors.first('name') }}
            </b-form-invalid-feedback>
          </b-form-fieldset>
          <b-row>
            <b-col md="4">
              <b-form-fieldset label="Estado">
                <b-form-select v-model="item.state" class="mb-3">
                  <option value="0">Inactivo</option>
                  <option value="1">Activo</option>
                </b-form-select>
              </b-form-fieldset>
            </b-col>
            <b-col md="4">
              <b-form-fieldset label="Escalão">
                <b-form-select v-model="item.family_member_type_id" class="mb-3" :options="memberTypes">
                  <template v-slot:first>
                    <b-form-select-option :value="null" >---</b-form-select-option>
                  </template>
                </b-form-select>
              </b-form-fieldset>
            </b-col>
            <b-col md="4">
            </b-col>
          </b-row>
          <b-form-fieldset label="Imagem">
            <b-form-input type="text" name="image_url" v-model="item.image_url" placeholder="Imagem" v-validate="{ required: false }" :state="validateState('image_url')" data-vv-validate-on="change" ></b-form-input>
            <b-form-invalid-feedback>
              {{ errors.first('image_url') }}
            </b-form-invalid-feedback>
          </b-form-fieldset>
          <b-form-fieldset label="Descrição">
            <b-form-textarea type="text" :rows="10" name="notes" v-model="item.description" placeholder="Descrição" :state="validateState('description')" data-vv-validate-on="change" ></b-form-textarea>
            <b-form-invalid-feedback>
              {{ errors.first('description') }}
            </b-form-invalid-feedback>
          </b-form-fieldset>



          <div slot="footer">
            <div class="row">
              <div class="col-sm-3">
                <router-link :to="{name:baseRoute + '.index'}" size="sm" variant="danger"><i class="fa fa-ban"></i> Cancelar</router-link>

              </div>
              <div class="col-sm-9 text-right">
                <b-button type="submit" size="sm" variant="primary"><i class="fa fa-save"></i> Gravar</b-button>
                <b-button type="button" v-on:click="validateBeforeSubmit($event,true)" size="sm" variant="primary"><i class="fa fa-save"></i> Gravar e fechar</b-button>
              </div>
            </div>
          </div>
        </b-card>

        <b-card>
          <div slot="header">
            <strong>Anos</strong> <router-link class="pull-right" :to="{name:'activity_years.create', params: {activity_id: item.id} }" size="sm" ><i class="fa fa-plus"></i> adicionar</router-link>
          </div>
          <b-table striped hover :items="item.years.data" :fields="yearsFields">
            <template v-slot:cell(state)="data">
              {{ states.translate(data.value, 'states') }}
            </template>
            <template v-slot:cell(show_details)="data">
              <router-link :to="{name:'activity_years.edit', params: {id: data.item.id} }" size="sm" ><i class="fa fa-edit"></i></router-link>
            </template>

            <template v-slot:row-details="row">
              <b-card>

                <b-form-fieldset label="Ano">
                  <b-form-input type="number" name="activity_year" v-model="row.item.activity_year" placeholder="Ano" v-validate="{ required: true }" :state="validateState('activity_year')" data-vv-validate-on="change" ></b-form-input>
                  <b-form-invalid-feedback>
                    {{ errors.first('activity_year') }}
                  </b-form-invalid-feedback>
                </b-form-fieldset>
              </b-card>
            </template>
          </b-table>
        </b-card>
      </div>
      <!--/.col-->
      <div class="col-md-6">
        <b-card>
          <div slot="header">
            <strong>Limites</strong>
          </div>
          <b-form-fieldset label="Máximo participantes">
            <b-form-input type="number" name="max_participants" v-model="item.settings.limits.max" placeholder="Máximo participantes" v-validate="{ required: true }" :state="validateState('max_participants')" data-vv-validate-on="change" ></b-form-input>
            <b-form-invalid-feedback>
              {{ errors.first('max_participants') }}
            </b-form-invalid-feedback>
          </b-form-fieldset>
          <div class="mb-3" >
            <h5>Rapazes / Raparigas</h5>
            <b-row>
              <b-col>
                <b-form-fieldset label="Rapazes">
                  <b-form-input type="number" name="limits_m" v-model="item.settings.limits.gender.m" placeholder="Rapazes" v-validate="{ required: true }" :state="validateState('limits_m')" data-vv-validate-on="change" ></b-form-input>
                  <b-form-invalid-feedback>
                    {{ errors.first('limits_m') }}
                  </b-form-invalid-feedback>
                </b-form-fieldset>
              </b-col>
              <b-col>
                <b-form-fieldset label="Raparigas">
                  <b-form-input type="number" name="limits_f" v-model="item.settings.limits.gender.f" placeholder="Raparigas" v-validate="{ required: true }" :state="validateState('limits_f')" data-vv-validate-on="change" ></b-form-input>
                  <b-form-invalid-feedback>
                    {{ errors.first('limits_f') }}
                  </b-form-invalid-feedback>
                </b-form-fieldset>
              </b-col>
            </b-row>
          </div>
          <div class="mb-3" >
            <h5>Veteranos / Novos</h5>
            <b-row>
              <b-col>
                <b-form-fieldset label="Veteranos">
                  <b-form-input type="number" name="limits_vet_vet" v-model="item.settings.limits.veterans.veterans" placeholder="Veteranos" v-validate="{ required: true }" :state="validateState('limits_vet_vet')" data-vv-validate-on="change" ></b-form-input>
                  <b-form-invalid-feedback>
                    {{ errors.first('limits_vet_vet') }}
                  </b-form-invalid-feedback>
                </b-form-fieldset>
              </b-col>
              <b-col>
                <b-form-fieldset label="Novos">
                  <b-form-input type="number" name="limits_vet_new" v-model="item.settings.limits.veterans.new" placeholder="Novos" v-validate="{ required: true }" :state="validateState('limits_vet_new')" data-vv-validate-on="change" ></b-form-input>
                  <b-form-invalid-feedback>
                    {{ errors.first('limits_vet_new') }}
                  </b-form-invalid-feedback>
                </b-form-fieldset>
              </b-col>
            </b-row>
          </div>
          <div class="mb-3" >
            <h5>Região</h5>
            <b-row>
              <b-col md="6" v-for="region in master_regions" v-bind:key="region.id">
                <h6>{{ region.name }}</h6>
                <b-row>
                  <b-col md="6">
                    <b-form-fieldset label="Percentagem Max">
                      <b-form-input type="number" :min="0" :max="100" :name="'limits_region_'+region.id" v-model="item.settings.limits.regions[region.id]" :placeholder="region.name" v-validate="{ required: true, min:0, max:100 }" :state="validateState('limits_region_'+region.id)" data-vv-validate-on="change" ></b-form-input>
                      <b-form-invalid-feedback>
                        {{ errors.first('limits_region_'+region.id) }}
                      </b-form-invalid-feedback>
                    </b-form-fieldset>
                  </b-col>
                  <b-col md="6">
                    <b-form-fieldset label="Mínimo participantes">
                      <b-form-input type="number" :name="'min_region_'+region.id" v-model="item.settings.limits.min_regions[region.id]" :placeholder="region.name" v-validate="{ required: true }" :state="validateState('min_region_'+region.id)" data-vv-validate-on="change" ></b-form-input>
                      <b-form-invalid-feedback>
                        {{ errors.first('min_region_'+region.id) }}
                      </b-form-invalid-feedback>
                    </b-form-fieldset>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </div>

          <b-table :items="capacities" :fields="limitsFields">
          </b-table>

        </b-card>

      </div>
      <!--/.col-->
    </div>
  </form>

</div>
</template>

<script>
import States from '@/components/Lists.js'
export default {
  name: 'ActivitiesEdit',
  props: ['id'],
  data() {
    return {
      url: 'activities',
      baseRoute: 'activities',
      dataLoaded: false,
      memberTypes: [],
      regions: [],
      master_regions: [],
      states: States,
      yearsFields: [{
        key: 'activity_year',
        label: 'Ano',
        sortable: true
      }, {
        key: 'state',
        label: 'Estado',
        sortable: true
      }, {
        key: 'show_details',
        label: '',
        sortable: true
      }],
      limitsFields: [{
        key: 'who',
        label: '',
        sortable: true
      }, {
        key: 'boys',
        label: 'M',
        sortable: true
      }, {
        key: 'girls',
        label: 'F',
        sortable: true
      }, {
        key: 'boys_vet',
        label: 'M V',
        sortable: true
      }, {
        key: 'boys_new',
        label: 'M C',
        sortable: true
      }, {
        key: 'girls_vet',
        label: 'F V',
        sortable: true
      }, {
        key: 'girls_new',
        label: 'F C',
        sortable: true
      }],
      item: {
        surname: '',
        state: 1,
        email: '',
        code: '',
        settings: {
          limits: {
            max: 48,
            regions: [],
            gender: {
              m: 50,
              f: 50
            },
            veterans: {
              veterans: 50,
              new: 50
            },
            regions: {},
            min_regions: {}
          }
        },
        years: {
          data:[]
        }
      }
    }
  },
  computed: {
    capacities() {
      let caps = []
      let limits = this.item.settings.limits
      let max = limits.max
      let max_m = limits.gender.m/100
      let max_f = limits.gender.f/100
      let max_vet = limits.veterans.veterans /100
      let max_new = limits.veterans.new /100

      caps.push({who: 'Geral', boys: Math.round(max * max_m)  , girls: Math.round(max * max_f), girls_vet: '', boys_vet: '', girls_new: '', boys_new: '' })
      caps.push({who: 'Veteranos', boys: Math.round(max * max_m * max_vet)  , girls: Math.round(max * max_f * max_vet ), girls_vet: '', boys_vet: '', girls_new: '', boys_new: '' })
      caps.push({who: 'Caloiros', boys: Math.round(max * max_m * max_new)  , girls: Math.round(max * max_f * max_new ), girls_vet: '', boys_vet: '', girls_new: '', boys_new: '' })

      for(var x in limits.regions) {
        let x_limit = limits.regions[x] /100
        let region_name = ''
        console.log(this.master_regions)
        for(var i=0; i<this.master_regions.length; i++) {
          if(x == this.master_regions[i].id) {
            region_name = this.master_regions[i].name

          }
        }
        let d = {}
        d.who = region_name
        d.boys =  Math.round(max * max_m * x_limit)
        d.girls =  Math.round(max * max_f * x_limit)
        d.girls_vet =  Math.round(max * max_f * x_limit * max_vet)
        d.boys_vet =  Math.round(max * max_m * x_limit * max_vet)
        d.girls_new =  Math.round(max * max_f * x_limit * max_new)
        d.boys_new =  Math.round(max * max_m * x_limit * max_new)
        caps.push(d)
      }

      return caps
    }
  },
  methods: {
    validateBeforeSubmit(evt, close) {
      evt.preventDefault()
      console.log('check validation')
      this.$validator.validateAll().then((result) => {
        console.log('validation results:', result)
        if (result) {
          console.log('all fields ok. submit')
          this.submit(evt, close)
          return
        }
        this.$bvToast.toast('Tem campos inválidos', { autoHideDelay: 5000, variant: 'danger', solid: true})
      })
    },
    validateState(ref) {
      if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
        return !this.errors.has(ref)
      }
      return null
    },
    submit(e, close) {
      e.preventDefault()
      var data = {
        data: this.item
      }
      if (this.item.id) {
        this.axios.put(this.url + '/' + this.item.id, data)
          .then(response => {
            this.item = response.data.data
            this.$bvToast.toast('item gravado com sucesso', { autoHideDelay: 5000, variant: 'success', solid: true})
            if (close) {
              this.$router.push({
                name: this.baseRoute + '.index'
              })
            }
          })
          .catch(response => {
            this.$bvToast.toast('Não foi possivel gravar', { autoHideDelay: 5000, variant: 'danger', solid: true})
          })
      } else {
        this.axios.post(this.url, data)
          .then(response => {
            this.item = response.data.data
            this.$bvToast.toast('item gravado com sucesso', { autoHideDelay: 5000, variant: 'success', solid: true})
            this.$router.push({
              name: this.baseRoute + '.edit',
              params: {
                id: this.item.id
              }
            })
          })
          .catch(response => {
            this.$bvToast.toast('Não foi possivel gravar', { autoHideDelay: 5000, variant: 'danger', solid: true})
          })
      }
    }
  },
  created() {
    var id = this.$route.params.id
    if (typeof id !== 'undefined') {
      this.axios.get(this.url + '/' + id)
        .then(response => {
          this.item = response.data.data
          if(!this.item.settings) {
            this.item.settings = {
              limits: {
                max: 48,
                regions: [],
                gender: {
                  m: 50,
                  f: 50
                },
                veterans: {
                  veterans: 50,
                  new: 50
                },
                regions: {},
                min_regions: {}
              }
            }

          }
          this.dataLoaded = true
        })
        .catch(response => {
          this.$bvToast.toast('Esta actividade não existe', { autoHideDelay: 5000, variant: 'danger', solid: true})
          this.$router.push({
            name: this.baseRoute + '.index'
          })
        })
    } else {
      this.dataLoaded = true
    }
    this.axios.get('regions/lst').then(response => {
      this.regions = response.data.data
    })
    this.axios.get('master_regions/lst').then(response => {
      this.master_regions = response.data.data
    })
    this.axios.get('familymembertypes/lst').then(response => {
      this.memberTypes = response.data.data
    })
  }
}
</script>
